import React, { FunctionComponent } from "react";
import styles from "./Embed.module.scss";
import EmbedBlockProps from "./EmbedProps.interface";

import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import setInViewClasses from "blocks/hooks/setInViewClasses";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";

const Embed: FunctionComponent<EmbedBlockProps> = (props): JSX.Element => {
  const wrapperClasses = getWrapperClasses(props.settings);
  const wrapperStyles = useWrapperStyles(props.settings);
  const { inViewElementRef, inViewClasses } = setInViewClasses(styles);

  const { splitClasses, splitStyles } = useSplitBackground(props);

  return (
    <section
      className={combineClasses(
        styles.wrapper,
        inViewClasses,
        ...wrapperClasses
      )}
      style={{ ...wrapperStyles, ...splitStyles }}
      ref={inViewElementRef}
    >
      <div className={combineClasses(styles.container, ...splitClasses)}>
        <div className={styles.embed}>
          {props.content.iframeUrl ? (
            <iframe
              className={styles.iframe}
              src={props.content.iframeUrl}
              title={props.content.title}
              frameBorder="0"
              scrolling="no"
              width="100%"
              height="1100"
            ></iframe>
          ) : null}
        </div>
      </div>
      {props.settings.backgroundMedia?.[0] &&
      props.settings.backgroundMedia.length > 0 ? (
        <BackgroundMedia
          key={props.contentUdi}
          {...props.settings.backgroundMedia[0]}
        />
      ) : null}
    </section>
  );
};

export default Embed;
